import type { Company } from '../types/company';

export const companies: Company[] = [
  {
    rank: 1,
    name: 'tkxel',
    url: 'https://tkxel.com/',
    location: 'Global delivery for UK teams',
    focus: 'End-to-end AI workflow automation, AI agents and integrations',
    bestFor: 'Mid-market and enterprise teams that want one partner from discovery to optimisation',
    engagement: 'POC → implementation → monitoring and optimisation',
    featured: true,
    summary: [
      'tkxel is a software and AI engineering company with a dedicated AI workflow automation practice. Its approach covers the whole lifecycle: identifying the processes worth automating, validating them through a proof of concept, then moving into production with integrations into CRMs, ERPs, helpdesks, databases and internal tools.',
      'What stands out is the emphasis on controlled autonomy. tkxel builds AI agents that handle multi-step work such as triaging requests, pulling records, drafting responses and updating systems, while keeping human approval steps wherever a decision carries financial, legal or customer risk. After launch, the team focuses on monitoring and continuous optimisation, tracking accuracy, exceptions and throughput so workflows improve over time instead of drifting.',
    ],
    capabilities: [
      'AI workflow automation and process design',
      'AI agents for multi-step tasks',
      'CRM, ERP and API integrations',
      'Proof of concept (POC) validation',
      'Production implementation',
      'Human-in-the-loop approval',
      'Monitoring and optimisation',
    ],
  },
  {
    rank: 2,
    name: 'Swarm Labs',
    url: 'https://swarmlabs.io/',
    location: 'Manchester',
    focus: 'Custom software, workflow automation and AI agents',
    bestFor: 'Teams that need internal tools and the automations around them built together',
    engagement: 'Scoped builds with ongoing support',
    summary: [
      'Swarm Labs is a Manchester-based software development studio that builds applications, internal tools, APIs and automations. Its AI automation service pairs rules-based workflow automation for repetitive steps with AI agents for the judgement calls, wired into the tools a business already runs and with a human in the loop where it matters.',
    ],
    capabilities: ['Workflow automation', 'AI agents', 'Custom apps and APIs', 'System integration'],
  },
  {
    rank: 3,
    name: 'flowio',
    url: 'https://www.flowio.co.uk/',
    location: 'Glasgow HQ, remote across England',
    focus: 'n8n and Python workflows, voice agents, chatbots and CRM integration',
    bestFor: 'SMEs automating enquiries, bookings and record updates',
    engagement: 'Discovery-led builds with continuous improvement',
    summary: [
      'flowio is a UK AI automation agency headquartered in Glasgow that serves businesses across the UK, including England, through remote delivery. Its work centres on custom workflow automation built with n8n and Python, AI voice agents, chatbots and CRM integrations. Because n8n can be self-hosted, it suits organisations that want tighter control over where workflow data lives.',
    ],
    capabilities: ['n8n workflow automation', 'AI voice agents', 'Chatbots', 'CRM integration'],
  },
  {
    rank: 4,
    name: 'Ferrous Labs',
    url: 'https://ferrouslabs.co.uk/',
    location: 'London',
    focus: 'Agentic workflows and domain-specific AI for expert-led firms',
    bestFor: 'Professional services and technical firms with specialist processes',
    engagement: 'Opportunity validation, then prioritised builds',
    summary: [
      'Ferrous Labs is a London-based AI engineering studio focused on specialist, expert-led businesses. Its workflow automation uses agent-driven systems for processes such as document triage, invoice processing, supplier coordination and reporting, alongside retrieval-based knowledge tools and predictive models. Engagements start by validating opportunities and prioritising the builds with the strongest expected return.',
    ],
    capabilities: ['Agentic workflows', 'Document triage', 'RAG knowledge systems', 'Predictive models'],
  },
  {
    rank: 5,
    name: 'The Automation Consultants',
    url: 'https://theautomationconsultants.co.uk/',
    location: 'UK-wide',
    focus: 'Independent, ROI-first automation consultancy',
    bestFor: 'Mid-market businesses that want a tool-agnostic roadmap first',
    engagement: 'Fixed-fee discovery, audit, build and optional retainer',
    summary: [
      'The Automation Consultants is a UK consultancy that begins by deciding what is worth automating at all. It maps processes, ranks opportunities by expected return and then implements in the client’s tool of choice, whether that is Zapier, Make, n8n, Power Automate or a custom build. It states that it takes no platform commissions, and structures work in fixed-fee phases.',
    ],
    capabilities: ['Process mapping', 'ROI prioritisation', 'Tool-agnostic builds', 'AI document intake'],
  },
];
